import React from "react";
import { PhoneIcon, PhoneXMarkIcon, UserIcon } from "@heroicons/react/24/outline";
import { useCall } from "../../contexts/CallContext";
import useRingingSound from "../../hooks/useRingingSound";

const IncomingCallModal = () => {
  const { callStatus, callerInfo, acceptCall, rejectCall } = useCall();

  useRingingSound(callStatus === "ringing");

  if (callStatus !== "ringing" || !callerInfo) return null;

  const displayName =
    [callerInfo.firstName, callerInfo.lastName].filter(Boolean).join(" ").trim() ||
    callerInfo.username ||
    callerInfo.agentDetails?.agent_name ||
    "Unknown Caller";

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-black bg-opacity-60 transition-opacity backdrop-blur-sm"></div>

        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
          <div className="bg-gradient-to-r from-green-500 to-green-600 px-6 py-8 text-center">
            <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
              {callerInfo.agentDetails?.agentImage ? (
                <img
                  src={callerInfo.agentDetails.agentImage}
                  alt={displayName}
                  className="w-16 h-16 rounded-full object-cover"
                />
              ) : (
                <UserIcon className="h-10 w-10 text-white" />
              )}
            </div>
            <h3 className="text-xl font-semibold text-white mb-1">
              {displayName}
            </h3>
            <p className="text-green-100 text-sm">Incoming Call</p>
          </div>

          <div className="p-6">
            <div className="flex justify-center space-x-6">
              <button
                onClick={rejectCall}
                className="flex flex-col items-center p-4 rounded-full bg-red-100 hover:bg-red-200 text-red-700 transition-colors"
              >
                <PhoneXMarkIcon className="h-8 w-8" />
                <span className="text-xs mt-1 font-medium">Decline</span>
              </button>
              <button
                onClick={acceptCall}
                className="flex flex-col items-center p-4 rounded-full bg-green-100 hover:bg-green-200 text-green-700 transition-colors"
              >
                <PhoneIcon className="h-8 w-8" />
                <span className="text-xs mt-1 font-medium">Accept</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomingCallModal;
